export const COMPANY_NAME = "Electra Bay, LLC";
export const COMPANY_SHORT = "Electra Bay";
export const COMPANY_INITIALS = "EB";
export const COMPANY_ADDRESS_FULL = "142 Full Sun, Irvine, California, US 92618-0876";
export const COMPANY_LOCATION = "Irvine, California";
export const COMPANY_REGION = "Irvine, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=142%20Full%20Sun%2C%20Irvine%2C%20California%2C%20US%2092618-0876";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1708004663889-7ce82b7063b3?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Electra Bay, LLC" },
  { "label": "Location", "value": "Irvine, California" },
  { "label": "Address", "value": "142 Full Sun" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Electra Bay, LLC" },
  { "label": "City / State", "value": "Irvine, California" },
  { "label": "Address", "value": "142 Full Sun, Irvine, California, US 92618-0876" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Aviation-minded", "body": "A calm public profile inspired by light aircraft and open skies." },
  { "icon": "✦", "title": "Based in Irvine", "body": "Directory information is presented clearly for visitors." },
  { "icon": "◌", "title": "Simple details", "body": "Find the organization name and public location in one place." },
];
